import { useEffect } from 'react';
import { updateUserVisitorsData } from '../../../util/api';

export const useUpdateUserVisitors = ({
    riderListing,
    currentUserId,
    isOwnListing,
    currentUserIsRider,
    authorId,
    listingId,
}) => {
    /**
     * riderListing is a new object whenever marketplace entities are added,
     * so depend on its id to report a view only once
     */
    const riderListingId = riderListing?.id?.uuid;

    useEffect(() => {
        /**
         * only available riders with complete profile
         * are allowed to become visitors
         */
        if (!riderListingId) return;
        if (!currentUserId) return;
        if (isOwnListing) return;
        if (!currentUserIsRider) return;
        if (!authorId) return;
        /**
         * visitedEntryId - listingId
         * visitorRepresentationId - riderId
         */
        updateUserVisitorsData(authorId, listingId.uuid, currentUserId, 'horse');
    }, [currentUserId, currentUserIsRider, authorId, listingId.uuid, riderListingId]);
};
